export const supportTranslations = {
  CONFIGURATOR_SUPPORT: "Configurator Support",
  TROX_CONFIGURATOR_SUPPORT: "TROX CONFIGURATOR SUPPORT",
  DETAILS: "Details",
  ATTACHMENTS_OPTIONAL: "Attachments (optional)",
  MESSAGE_REQUIRED: "Message *",
  CATEGORISATION: "Categorization",
  BUG: "Bug",
  FEEDBACK: "Feedback",
  FEEDBACK_MESSAGE_PLACEHOLDER: "Enter your feedback",
  SENDER_EMAIL: "Sender",
  SENDER_EMAIL_TOOLTIP:
    "In case of divergent E-Mail address please adjust the sender E-Mail",
  SUBJECT: "Subject",
  SUBJECT_PLACEHOLDER: "Enter subject line",
  MESSAGE_SUPPORT_PLACEHOLDER:
    "Steps to reproduce, Current behavior, Expected behavior",
  UPLOAD_DATA: "Upload Data",
  MAX_FILE_SIZE: "Maximum file size:",
  ATTACHED_FILES: "Attached Files",
  INVALID_EMAIL_FORMAT: "Please enter a valid email address",
  FILE_ALLREADY_ATTACHED: "The file is already attached",
  FILE_TOO_LARGE_10MB: "File is too large. Maximum size: 10 MB",
  FILE_TYPE_NOT_ALLOWED:
    "This file type is not allowed. Allowed types: PDF, PNG, JPG, TXT, DOC, DOCX, XLS, XLSX",
  MAX_ATTACHMENTS_EXCEEDED: "You can upload a maximum of 5 files",
  MAX_UPLOAD_SIZE_EXCEEDED: "Maximium upload size exceeded",
  MESSAGE_TOO_SHORT: "Message must be at least 5 characters long",
  MESSAGE_TOO_LONG: "Message must not exceed 30,000 characters",
  SUBJECT_TOO_LONG: "Subject must not exceed 50 characters",
  SUBJECT_TOO_SHORT: "Subject must be at least 4 characters long",
  SUBMISSION_SUCCESSFUL: "Request submitted successfully",
  SUPPORT_TEAM_WILL_CONTACT_YOU: "Our support team will contact you shortly",
  SUPPORT_MESSAGE_TEMPLATE_STEPS: "Steps to reproduce:",
  SUPPORT_MESSAGE_TEMPLATE_CURRENT_BEHAVIOR: "Current behavior:",
  SUPPORT_MESSAGE_TEMPLATE_EXPECTED_BEHAVIOR: "Expected behavior:",
  SENDING: "Sending",
  SEND: "Send",
  ERROR: "Error",
};
